var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comments-input-container"},[_c('textarea',{staticClass:"comments-input",attrs:{"placeholder":"Anything else you would like to share?"},on:{"input":function (event) { return _vm.setAnswer(event.target.value); }}})])}
var staticRenderFns = []

export { render, staticRenderFns }